export default "__VITE_ASSET__C$4mWG6O__"